import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative w-full min-h-[520px] md:min-h-[620px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Soft%20minimalist%20fashion%20lifestyle%20scene%20with%20neutral%20cream%20and%20beige%20textures%2C%20warm%20natural%20lighting%2C%20elegant%20product%20displays%20with%20clothing%20and%20accessories%20artfully%20arranged%2C%20organic%20shapes%2C%20clean%20aesthetic%2C%20editorial%20photography%20with%20soft%20shadows%2C%20modern%20European%20style%2C%20light%20warm%20tones&width=1600&height=900&seq=hero-bg-main-01&orientation=landscape"
          alt="OOPBuy Spreadsheet Deutschland"
          className="w-full h-full object-cover object-center"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/40"></div>

      <div className="relative z-10 w-full text-center px-4 md:px-6 pt-16">
        <div className="max-w-3xl mx-auto">
          <p className="text-white/80 text-xs md:text-sm font-medium tracking-widest uppercase mb-3 md:mb-4">
            Trusted by Thousands
          </p>
          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-4 md:mb-5">
            OOPBuy Spreadsheet <br />
            <span className="text-white/90">Deutschland</span>
          </h1>
          <p className="text-white/70 text-sm md:text-base max-w-xl mx-auto mb-6 md:mb-8 leading-relaxed">
            Der ultimative Guide 2026 – Entdecke die besten OOPBuy Spreadsheet Produkte, Kategorien und Verkäufer. Sicher, schnell und transparent zum besten Spreadsheet-Erlebnis.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-white text-sm font-semibold rounded-full hover:bg-primary-600 transition-all cursor-pointer whitespace-nowrap"
            >
              OOPBuy Spreadsheet
              <i className="ri-arrow-right-up-line"></i>
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-6 py-3 bg-white/15 backdrop-blur-sm text-white border border-white/30 text-sm font-semibold rounded-full hover:bg-white/25 transition-all cursor-pointer whitespace-nowrap"
            >
              Buy It Now
              <i className="ri-arrow-right-up-line"></i>
            </a>
            <Link
              to="/artikel/oopbuy-spreadsheet-guide"
              className="inline-flex items-center gap-2 px-6 py-3 text-white/90 text-sm font-medium rounded-full hover:text-white hover:bg-white/10 transition-all cursor-pointer whitespace-nowrap"
            >
              Guide lesen
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-background-50 to-transparent"></div>
    </section>
  );
}